import React from 'react';
import classnames from 'classnames';
import ReactHtmlParser from 'react-html-parser';
import queryString from 'querystring';
import PopupMultiSelectButton from '../common/popupMultiSelectButton';
import Message from '../common/message';
import Widget from '../common/widget';
import ResponsiveTable from '../layoutItems/responsiveTable';
import Paging from '../common/pagingComponent';
import BbInput from '../styling/bbInput';
import generateLabel from './userLabelGenerator';
import NoDataComponent from '../common/noDataComponent';
import BbDatePicker from "../common/datePicker";
import { throttle } from 'lodash';
import { Formik, Form } from 'formik';
import { Translate, withLocalize } from 'react-localize-redux';
import { apiGet, apiPost, getHostApi, hasPermission } from '../../store/apiWrapper';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { domainActions } from '../../store/domainStore';
import { Circles } from '../common/loadingComponent';
import { isNullOrUndefined } from '../../store/storeFunctions';

import './reportHistory.scss';
import { searchActions } from '../../store/searchStore';

class ReportHistory extends React.Component {
    mounted = true;

    state = {
        users: [],
        usersLoading: false,
        usersError: null,
        firstSearch: false,
        transactions: null,
        transactionsLoading: false,
        transactionsError: null,
        exportLoading: false,
        exportError: false,
        page: null,
        totalCount: null,
        values: null
    }

    pageSize = 30;

    componentDidMount() {
        if (hasPermission(null, 'UserInfoConsumptionForWholeClient')) {
            this.setState({ usersLoading: true });
            apiGet(`${getHostApi()}/api/account/users`, null,
                res => {
                    if (!this.mounted) {
                        return;
                    }
                    this.setState({
                        users: res.data.map(user =>
                            ({ label: generateLabel(user.firstName, user.surname, user.userName), value: user.id })
                        ),
                        usersLoading: false
                    });
                },
                _ => this.mounted && this.setState({ usersError: this.props.translate('Common.Error'), usersLoading: false })
            );
        } else {
            this.setState({ users: [this.getCurrentUser()] });
        }
        this.props.ensureDomainData('report-types');
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    render() {
        var lastMonth = new Date();
        lastMonth.setDate(lastMonth.getDate() - 30);
        return (<>
            <div className='content-root report-history-content-root'>
                <Widget
                    className='widget' header='Common.Searching'
                    isLoading={this.state.usersLoading} initialExpanded={true} disableExpand={true}
                >
                    {this.state.usersLoading ? <Circles /> : <>
                        {this.state.usersError && <><Message type='error' message={this.state.usersError} /><br /></>}
                        <Formik
                            ref={(el) => this.formRef = el}
                            initialValues={{
                                from: lastMonth,
                                to: new Date(),
                                user: hasPermission(null, 'UserInfoConsumptionForWholeClient') ?
                                    null : this.getCurrentUser(),
                                reportTypes: { all: [], parent: [] }
                            }}
                            onSubmit={values => this.submitValues(values)}
                            render={({ values, setFieldValue }) => (
                                <Form>
                                    <BbInput type='select-noformik' label={this.props.translate('Common.User')} placeholder={{ type: 'column' }}
                                        name='user' className='field' options={this.state.users} selectPlaceholder={`${this.props.translate("Common.User")}...`} value={values.user}
                                        onChange={e => setFieldValue('user', e)} isClearable
                                        isDisabled={!hasPermission(null, 'UserInfoConsumptionForWholeClient')} />
                                    <BbInput type='custom' label={this.props.translate('User.ReportsHistory.ReportType')} placeholder={{ type: 'column' }} custom={
                                        <PopupMultiSelectButton
                                            data='report-types'
                                            name='reportTypes'
                                            popupSize='medium'
                                            title={this.props.translate('User.ReportsHistory.ReportType')}
                                            onClick={() => this.props.ensureDomainData('report-types')}
                                            selection={values.reportTypes}
                                            handleChange={(all, parent) => setFieldValue('reportTypes', { all: all, parent: parent })} />
                                    } />
                                    <div className='field bb-field'>
                                        <div className='control'>
                                            <div className="columns">
                                                <div className="column is-4 bb-input-label-column">
                                                    <div className="label-wrapper vertically-centered">
                                                        <span className="marketing-label"><Translate id="Report.Common.Date" /></span>
                                                    </div>
                                                </div>
                                                <div className="column is-4">
                                                    <BbDatePicker
                                                        formik={this.formRef}
                                                        field={'from'}
                                                        value={values.from}
                                                        formDateFormat={"YYYY-MM-DD"}
                                                        placeholder={this.props.translate("Report.Common.From")}
                                                        yearsBack={20} />
                                                </div>
                                                <div className="column is-4">
                                                    <BbDatePicker
                                                        formik={this.formRef}
                                                        field={'to'}
                                                        value={values.to}
                                                        formDateFormat={"YYYY-MM-DD"}
                                                        placeholder={this.props.translate("Report.Common.To")}
                                                        yearsBack={20} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {!this.state.exportLoading && <div className='column is-narrow text-align-center'>
                                        <button
                                            type="button"
                                            className={classnames('bb-button is-primary gradient-1-secondary bold-bb-button', { 'is-square': localStorage.locales_button_style === 'square' })}
                                            onClick={e => { e.preventDefault(); this.exportTransactions(values); }}
                                        >
                                            <Translate id='Common.Export' />
                                        </button>
                                        <button className={classnames('bb-button is-primary gradient-1 bold-bb-button', { 'is-square': localStorage.locales_button_style === 'square' })} type="submit">
                                            <Translate id='Search.Common.Search' />
                                        </button>
                                    </div>}
                                    {this.state.exportLoading && <Circles />}
                                    {this.state.exportError && <Message type='error' message={this.state.exportError} />}
                                </Form>
                            )} />
                    </>}
                </Widget>
                {this.state.firstSearch &&
                    <Widget
                        className='widget' header='User.ReportsHistory.Results'
                        isLoading={this.state.transactionsLoading} initialExpanded={true} disableExpand={true}
                    >
                        {this.state.transactionsLoading ? <Circles /> : <>
                            {this.state.transactionsError && <div style={{ paddingTop: "1em" }}><Message type='error' message={this.state.transactionsError} /><br /></div>}
                            {Array.isArray(this.state.transactions) && this.state.transactions.length === 0 ?
                                <NoDataComponent style={{ paddingTop: "1em" }} />
                                : <div className='report-history'>
                                    <ResponsiveTable>
                                        <table className='table table-report-section'>
                                            <thead>
                                                <tr>
                                                    <th><Translate id='Common.User' /></th>
                                                    <th><Translate id='Common.DateTime' /></th>
                                                    <th><Translate id='Common.Description' /></th>
                                                    <th><Translate id='User.ReportsHistory.RegistrationCountry' /></th>
                                                    <th><Translate id='User.ReportsHistory.Account' /></th>
                                                    <th><Translate id='User.ReportsHistory.Price' /></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Array.isArray(this.state.transactions) && this.state.transactions.map(tran => (
                                                    <tr key={tran.id} className='colorize'>
                                                        <td data-label={this.props.translate('Common.User')}>
                                                            <span>{tran.username}</span>
                                                        </td>
                                                        <td data-label={this.props.translate('Report.RequestDate')}>
                                                            <span>{tran.requestDateFormated}</span>
                                                        </td>
                                                        <td data-label={this.props.translate('Common.Description')}>
                                                            <span>{ReactHtmlParser(tran.description)}</span>
                                                        </td>
                                                        <td data-label={this.props.translate('User.ReportsHistory.RegistrationCountry')}>
                                                            <span>{tran.registrationCountry}</span>
                                                        </td>
                                                        <td data-label={this.props.translate('User.ReportsHistory.Account')}>
                                                            <span>{tran.account}</span>
                                                        </td>
                                                        <td data-label={this.props.translate('User.ReportsHistory.Price')}>
                                                            <span>{tran.price}</span>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </ResponsiveTable>
                                    {this.state.transactions && this.renderPaging()}
                                </div>
                            }
                        </>}
                    </Widget>
                }
            </div>
        </>)
    }

    renderPaging = () =>
        (this.state.page && Math.ceil(this.state.totalCount / this.pageSize) > 1) ? (
            <div className='paging-wrapper'>
                <Paging selectedPage={this.state.page}
                    totalPages={Math.ceil(this.state.totalCount / this.pageSize)}
                    setPage={this.changePage} />
            </div>
        ) : null;

    submitValues = values => {
        if (this.state.usersError) {
            return;
        }
        this.setState({
            firstSearch: true, transactions: null, transactionsLoading: true, transactionsError: null,
            totalCount: null, values: values, page: 1
        });
        this.loadTransactions(values, 1);
    }

    exportTransactions = values => {
        if (this.state.usersError) {
            return;
        }
        this.setState({ exportLoading: true, exportError: null });
        this.loadTransactions(values)
    }

    changePage = page => {
        this.setState({ transactions: null, transactionsLoading: true, transactionsError: null, page: page });
        this.loadTransactions(this.state.values, page);
    }

    loadTransactions = (values, page) => (this.loadTransactionsThrottle = this.loadTransactionsThrottle || throttle((values, page) => {
        apiPost(
            `${getHostApi()}/api/account/report-history/${page ? 'data' : 'prepare-csv'}`,
            page ?
                {
                    page: page,
                    pageSize: this.pageSize
                } : {},
            {
                userId: values.user && values.user.value,
                from: values.from,
                to: values.to,
                reports: values.reportTypes.all.filter(report => report.value.indexOf('-') !== -1).map(report => report.value)
            },
            res => {
                if (!this.mounted) {
                    return;
                }
                if (page) {
                    if (this.state.page === page) {
                        this.setState({ transactionsLoading: false, transactions: res.data.transactions, totalCount: res.data.totalCount });
                    }
                } else {
                    this.setState({ exportLoading: false });
                    window.open(`/files/report-history/${res.data}`, "_blank");
                }
            },
            _ => this.mounted && (page ?
                this.setState({ transactionsLoading: false, transactionsError: this.props.translate('Common.Error') }) :
                this.setState({ exportLoading: false, exportError: this.props.translate('Common.Error') })
            )
        );
    }, 500))(values, page);

    getCurrentUser = () => ({
        label: generateLabel(
            this.props.authentication.profile.name,
            this.props.authentication.profile.surname,
            this.props.authentication.profile.username
        ),
        value: this.props.authentication.profile.id
    })
}

export default withLocalize(connect(
    state => ({ ...state.domain, ...state.userContext }),
    dispatch => bindActionCreators({ ...domainActions, ...searchActions }, dispatch)
)(ReportHistory));